export default __webpack_public_path__ + "static/media/doublearrow.4a344f03.svg";